export default "__VITE_ASSET__BZe_qT5Z__"